import { AttributeFilter, CollectionDesignation, CollectionFilter, ResultFilters } from "../common/interfaces";
import React from "react";
import { AvailabilityFilter, SortingBy } from "./components";

export interface FilterContextValue {
  availableAttributeFilters: AttributeFilter[];
  appliedAttributeFilters: AttributeFilter[];
  applyAttributeFilter: (filter: AttributeFilter) => void;
  clearAppliedAttributeFilters: () => void;

  availabilityFilter: AvailabilityFilter;
  clearAvailabilityFilters: () => void;
  applyAvailabilityFilter: (filter: Partial<AvailabilityFilter>) => void;

  collectionFilter: CollectionFilter;
  applyCollectionFilter: (filter: Partial<CollectionFilter>) => void;

  availableOnDemandFilters?: ResultFilters;
  availableSubscriptionFilters?: ResultFilters;
  availableSaleFilters?: ResultFilters;
}

const notImplemented = () => console.error("Not implemented in FilterContext");

export const defaultFilterContext: FilterContextValue = {
  availableAttributeFilters: [],
  appliedAttributeFilters: [],
  applyAttributeFilter: notImplemented,
  clearAppliedAttributeFilters: notImplemented,

  availabilityFilter: {
    availableNow: true,
    postcode: "",
    deliveryDates: {
      endDate: "",
      startDate: ""
    }
  },
  applyAvailabilityFilter: notImplemented,
  clearAvailabilityFilters: notImplemented,

  collectionFilter: {
    collectionDesignation: CollectionDesignation.All,
    sorting: SortingBy.Newest
  },
  applyCollectionFilter: notImplemented
};

export const FilterContext = React.createContext<FilterContextValue>(defaultFilterContext);
